
import { ISesBeurteilungsErgebnis } from './ApiTypesSes';

export const SES_BAHN = 'ses_bahn';
export const SES_TYP = 'ses_typ';
export const SES_UST = 'ust';

export const AGT_4GAS = '4gas';
export const AGT_OPAZIMETER = 'opazimeter';
export const AGT_KOMBI = 'kombi';
export const AGT_PARTIKEL_DC = 'partikel_dc';
export const AGT_PARTIKEL_CPC = 'partikel_cpc';
export const AGT_UNBEKANNT = '';

export const AUFTRAG_KATEGORIE_SES = 'ses';

export enum AdressArt {
  Auftraggeber = 'auftraggeber',
  Beauftragter = 'beauftragter',
  Untersuchungsstelle = 'beauftragter', // = Beauftragter, abweichende Benennung für bessere Lesbarkeit
  Lieferadresse = 'lieferadresse' // = Beauftragter, abweichende Benennung für bessere Lesbarkeit
}

export enum DokumentenStatus {
  NichtVorhanden,
  Angefordert,
  Erzeugt
}

export type IResponse<T> = IApiError | {
  ok: true;
  json: T
};

export interface IApiError {
  ok: false;
  error: string;
}

export interface IApiSuccess {
  success: boolean | string;
}

export interface IApiSuccessDate extends IApiSuccess {
  date?: string;
}

export interface IApiSuccessDaten extends IApiSuccess {
  vorhanden: boolean;
  wert?: string;
}

/** Basisinterface für paginierte Rückgabe von Laravel */
export interface IPaginatedResult {
  total: number;
  per_page: number;
  current_page: number;
  last_page: number;
  next_page_url?: string;
  prev_page_url?: string;
  from: number;
  to: number;
}

export interface IMesswerteSesVorhandenResponse {
  messwerte: boolean;
  vorgangid?: string;
}

export interface IProfile {
  anrede: string;
  auftragnehmer: string;
  comment?: string;
  creationdate: string;
  email: string;
  erfasstvon: string;
  failedpasswordattemptcount: number;
  failedpasswordanswerattemptwindowstart?: string;
  failedpasswordanswerattemptcount: number;
  failedpasswordattemptwindowstart?: string;
  hinweiseaufemailaenderungabgelehnt: number;
  isapproved: number;
  islockedout: number;
  kommentar?: string;
  lastactivitydate?: string;
  lastlockedoutdate: string;
  lastlogindate: string;
  lastpasswordchangeddate: string;
  linummer: string;
  loginmelden: number;
  minummer?: string;
  nachname: string;
  passwordanswer?: string;
  passwortaendernerforderlich: number;
  passwordquestion?: string;
  pinummer: string;
  projektleiter: boolean;
  portaladmin: boolean;
  userid: string;
  username: string;
  vorname: string;
  laborfunktionen?: string[];
}

export interface ILogin {
  token: string;
}

export interface IBefugnis {
  kuerzel: string;
  bezeichnung: string;
  giltvon?: string;
  giltbis?: string;
  lipi_nummer: string;
  gueltig: boolean;
  startdatum?: string;
  ablaufdatum?: string;
  kategorie?: string;
}

export interface IFreigabe {
  lizenznehmer: string;
  pi: string;
  gueltigvon: string;
  gueltigbis: string;
  name: string;
}

export interface IPersonalliste {
  li: string;
  pi: string;
  name: string;
  vorname: string;
  kuerzel?: string;
  giltvon?: string;
  giltbis?: string;
}

export interface IDienstleistung {
  kuerzel_dienstleistung: string;
  kuerzel_befugnis: string;
  lipi_nummer: string;
  giltvon: string;
  giltbis: string;
  sortierung: number;
  gueltig: boolean;
  bezeichnung: string;
}

export interface IAuftrag {
  anr: string;
  auftrag_name: string;
  auftragstatus: string;
  auftragnehmer: string;
  referenzdatum: string;
  refnr: string;
  erfasstvon: string;
  erfasstam: string;
  beauftragter_name1?: string;
  beauftragter_name2?: string;
  beauftragter_name3?: string;
  beauftragter_strasse?: string;
  beauftragter_land?: string;
  beauftragter_plz?: string;
  beauftragter_ort?: string;
  beauftragter_adressid?: number;
  beauftragter_tel?: string;
  beauftragter_email?: string;
  beauftragter_email2?: string;
  auftraggeber_name1: string;
  auftraggeber_name2?: string;
  auftraggeber_name3?: string;
  auftraggeber_strasse: string;
  auftraggeber_land?: string;
  auftraggeber_plz: string;
  auftraggeber_ort: string;
  auftraggeber_adressid?: number;
  auftraggeber_tel?: string;
  auftraggeber_email?: string;
  auftraggeber_email2?: string;
  bemerkung: string;
  verantwortlicher: string;
  informhaupttyp: string;
  rechnungstyp?: string;
  beauftragter_url?: string;
  auftraggeber_url?: string;
  auftragtyp: string;
  datumwiedervorlage?: string;
  statustext: string;
  abgeschlossen: boolean;
  inarbeit: boolean;
  vorgaenge: IVorgang[];
  dienstleistungen: IDienstleistung[];
  meta: IAuftragMeta[];
  lizenznehmer: string;
  kategorie: string;
  piname?: string;
  pivorname?: string;
  pi: {
    name: string;
    vorname: string;
    anrede: string;
    titel: string;
    nummer: string;
  };
  oeffentlicherlink?: string;
  untersuchungsstellenkennung?: string;
  objekte: IObjekt[];
  refnrkunde?: string;
  refdatumkunde?: string;
}

export interface IAuftragStatus {
  kuerzel: string;
  text: string;
}

export interface IVorgang {
  name: string;
  bemerkung?: string;
  datumvon: string;
  datumbis?: string;
  typ?: string;
  kuerzel_dienstleistung: string;
  anr: string;
  vorgangguid: string;
  informhaupttyp: string;
  auftragnehmer: string;
  vgstatus: string;
  sortierung: number;
  erfasstvon: string;
  erfasstam: string;
  statustext: string;
  abgeschlossen: boolean;
  korrekturvorgang: boolean;
  arbeitsmittel: IArbeitsmittel[];
  meta: IVorgangMeta[];
  formulardaten: IVorgangFormulardaten[];
  objekte?: IObjekt[];
  objekttyp: string;
  arbeitsmitteltyp: string;
}

export interface IVorgangFormularElement {
  kategorieguid: string;
  elementguid: string;
  kuerzel: string;
  text: string;
  typ: string;
  werte: string[];
  sortierung: number;
  optional: boolean;
  abhaengigvon: string;
  vorlage: string;
  platzhalter: string;
  abhaengigvon_auswahl: string;
}

export interface IVorgangFormularKategorie {
  kategorieguid: string;
  kuerzel: string;
  text: string;
  beschreibung: string;
  sortierung: number;
  formular_elemente?: IVorgangFormularElement[];
}

export interface IVorgangVorlage {
  dienstleistung: string;
  bezeichnung: string;
  id: number;
  vorlage: string;
  auswahl_arbeitsmittel: number;
  auswahl_objekte: number;
  auswahl_orte: number;
  formular_kategorien: IVorgangFormularKategorie[];
}

export interface IVorgangFormulardaten {
  vorgangguid: string;
  id: number;
  kategorieguid: string;
  kategoriekuerzel: string;
  kategorietext: string;
  elementguid: string;
  elementkuerzel: string;
  elementtext: string;
  elementtyp: string;
  wert: string;
}


export interface IMeta {
  bezeichnung: string;
  inhalt: string;
  zeitpunkt?: string;
  typ?: string;
}

export interface IAuftragMeta extends IMeta {
  anr?: string;
}

export interface IVorgangMeta extends IMeta {
  vorgangguid: string;
}

export interface IObjektMeta extends IMeta {
  objektguid?: string;
}

export interface IOrtMeta extends IMeta {
  ortguid: string;
}

export interface IArbeitsmittelMeta extends IMeta {
  arbeitsmittelguid: string;
}

export interface IObjektVorlageMeta {
  kategorie: string;
  detail: string;
  eigenschaft: string;
  datentyp: string;
  wert: string;
  quelle: number;
}

export interface IDokument {
  pfad: string;
  docid: string;
  docstatus?: string;
  titel: string;
  eintrag_guid: string;
  erfasstam: string;
  erfasstvon: string;
  dateiname: string;
  dateiendung: string;
  medium: string;
  status: number;
  eintragstatus: string;
  downloadfreigegeben?: boolean;
}

export interface IDokumentSuchErgebnis {
  docid: string;
  titel: string;
  datum: string;
}

export interface IThumbnail {
  docid: string;
  eintrag_guid: string;
  erfasstam: string;
  dateiname: string;
  dateiendung: string;
  thumbnail: string;
}

export interface IArbeitsmittel {
  arbeitsmittelnr: string;
  name: string;
  amstatus: string;
  pi: string;
  arbeitsmittelguid: string;
  giltbis: string;
  giltvon: string;
  typ: string;
  seriennummer: string;
  informhaupttyp: string;
  ortguid: string;
  qart: string;
  qnummer: string;
  lizenznehmer: string;
  erfasstvon?: string;
  erfasstam?: string;
  gueltigtage?: number;
  meta?: IArbeitsmittelMeta[];
}

export interface IObjekt {
  objektid: string;
  name: string;
  bemerkung?: string;
  status: string;
  informhaupttyp: string;
  objektguid: string;
  typ: string;
  lagerort?: string;
  sernr: string;
  hersteller: string;
  typbezeichnung: string;
  auftragnehmer: string;
  erfasstvon: string;
  erfasstam: string;
  statusText: string;
  aktiv: boolean;
  gesperrt: boolean;
  inpruefung: boolean;
  art?: string;
  meta?: IObjektMeta[];
  messmittelkennung?: string;
}

export interface IObjektVorlage {
  hersteller: string;
  modell: string;
  auftragnehmer: string;
  kategorie: string;
  kuerzel_befugnis?: string;
  giltvon?: string;
  giltbis?: string;
  gueltig: boolean;
  art: string;
  arttext?: string;
  meta: IObjektVorlageMeta[];
}

export interface IOrt {
  ortid: string;
  name: string;
  adressid: number;
  status: string;
  typ: string;
  informhaupttyp: string;
  ortguid: string;
  name1: string;
  name2?: string;
  name3?: string;
  strasse: string;
  land?: string;
  plz: string;
  ort: string;
  email: string;
  telefon: string;
  lizenznehmer: string;
  erfasstvon?: string;
  erfasstam?: string;
  arbeitsmittel: IArbeitsmittel[];
}

export type FahrzeugTyp = 'KRAD' | 'PKW' | 'LKW' | 'UNBEKANNT';

export interface IQmDokument {
  dateiname: string;
  titel: string;
}

export interface IQmDokumentation {
  befugnis: string;
  dokumente: Array<IQmDokument>;
}

// Wird zum Erfassen von Rechnungspositionen im Dienstleistungsnachweis genutzt
export interface IRechnungsposition {
  kuerzel_dienstleistung: string;
  sortierung: number;
  bezeichnung: string;
  preis: number;
  anzahl: number;
  gueltig: boolean;
}

// Wird zum Anzeigen bestehender Rechnungspositionen genutzt

export interface IRechnungStatus {
  wert: number;
  text: string;
}

export interface IRechnungArt {
  kuerzel: string;
  text: string;
}

export interface IRechPos {
  lfdnr: number;
  anzahl: number;
  preis: number;
  gesamtpreis: number;
  rechnungstext: string;
  text: string;
  textzusatz: string;
}

export interface IRechnung {
  renr: string;
  datum: string;
  status: number;
  statustext: string;
  art: string;
  typ: string;
  typtext: string;
  netto?: number;
  brutto?: number;
  offen?: number;
  refnr: string;
  positionen: IRechPos[];
}

export interface IVersionsinfo {
  Komponente: string;
  Version: string;
}

export interface ILoginResponse extends ILogin { }
export interface IProfileResponse extends IProfile { }
export interface IBenachrichtigungResponse extends IApiSuccess {
  text: string;
}
export interface IBefugnisListeResponse extends Array<IBefugnis> { }
export interface IDienstleistungsListeResponse extends Array<IDienstleistung> { }
export interface IAuftragsListeResponse extends Array<IAuftrag> { }
export interface IAuftragsListePaginatedResponse extends IPaginatedResult {
  data: Array<IAuftrag>;
}
export interface IAuftragAnzahlResponse extends IApiSuccess {
  anzahl: number;
}
export interface IAuftragDetailsResponse extends IAuftrag { }
export interface IAuftragAnlegenResponse extends IApiSuccess { }
export interface IAuftragDienstleistungResponse extends IApiSuccess { }
export interface IAuftragAbschliessenResponse extends IApiSuccess { }
export interface IAuftragZuruecksetzenResponse extends IApiSuccess { }
export interface IAuftragNichtErteiltResponse extends IApiSuccess { }
export interface IAuftragInArbeitResponse extends IApiSuccess { }
export interface IDokumenteResponse extends Array<IDokument> { }
export interface IDokumentenSucheResponse extends Array<IDokumentSuchErgebnis> { }
export interface IThumbnailsResponse extends Array<IThumbnail> { }
export interface IVorgangDetailsResponse extends IVorgang { }
export interface IVorgangFormularEingabenResponse extends IApiSuccessDate { }
export interface IVorgangFormularEingabenVollstaendigResponse extends IApiSuccess {
  hinweise: string[];
}
export interface IVorgangKorrigierenResponse extends IApiSuccess { }
export interface IVorgangVorlageResponse extends IVorgangVorlage { }
export interface IVorgangVorlageErzeugenResponse extends IApiSuccess {
  detail: {
    docid?: string;
    entryid: string;
  };
}
export interface IVorgangProtokollUploadResponse extends IApiSuccess { }
export interface IVorgangArbeitsmittelResponse extends Array<IArbeitsmittel> { }
export interface IVorgangArbeitsmittelEntfernenResponse extends IApiSuccess { }
export interface IVorgangObjekteResponse extends Array<IObjekt> { }
export interface IVorgangOrtSetzenResponse extends IApiSuccess { }
export interface IVorgangStatusResponse extends IApiSuccess { }
export interface IAuftragObjektSetzenResponse extends IApiSuccess { }
export interface IOrtsListeResponse extends Array<IOrt> { }
export interface IObjektListeResponse extends Array<IObjekt> { }
export interface IObjektListePaginatedResponse extends IPaginatedResult {
  data: Array<IObjekt>;
}
export interface IObjektVorlagenResponse extends Array<IObjektVorlage> { }
export interface IObjektVorlageResponse extends IObjektVorlage { }
export interface IObjektAnlegenResponse extends IApiSuccess { }
export interface IBeurteilungFahrzeugAufstellflaecheResponse extends ISesBeurteilungsErgebnis { }
export interface IBeurteilungSepAufstellflaecheResponse extends ISesBeurteilungsErgebnis { }
export interface IMessergebnisAuswertungResponse extends IApiSuccess {
  detail: {
    docid: string;
    entryid: string;
  };
}
export interface IBeurteilungAufstellflaecheKalibrierscheinResponse extends IApiSuccess {
  detail: {
    docid: string;
    entryid: string;
  };
}
export interface IAuftragAendernResponse extends IApiSuccess { }
export interface IFreigabenResponse extends Array<IFreigabe> { }
export interface IPersonallisteResponse extends Array<IPersonalliste> { }
export interface IQmDokumentationResponse extends Array<IQmDokumentation> { }
export interface IRechnungspositionenResponse extends Array<IRechnungsposition> { }
export interface IRechnungErzeugenResponse extends IApiSuccess { }
export interface IRechnungDetailsResponse extends IRechnung { }
export interface IRechnungListeResponse extends Array<IRechnung> { }
export interface IRechnungListePaginatedResponse extends IPaginatedResult {
  data: Array<IRechnung>;
}
export interface IVersionsinfoResponse extends Array<IVersionsinfo> { }
export interface IFeVersionInfoResponse extends IApiSuccess {
  branch: string;
  tag: string;
  hash: string;
  pipeline: string;
  date?: string;
}
export interface IRueckmeldungResponse extends IApiSuccess { }

export interface IAdresseVorhandenResponse extends IApiSuccess {
  vorhanden: boolean;
}

export interface IAdresse {
  adressid: number | undefined;
  name: string;
  zusatz: string;
  strasse: string;
  plz: string;
  tel1: string;
  bundesland: string;
  ort: string;
  untersuchungsstellenkennung: string;
  email: string;
  email2: string;
}
export interface IAdresseDatenResponse extends IApiSuccess, IAdresse {}

export interface IMessmittelVorhandenResponse extends IApiSuccess {
  vorhanden: boolean;
}

export interface IMessmittelUO {
  kuerzel: string;
  untersuchungsstelle: string;
  name: string;
  hersteller: string;
  seriennummer: string;
  status: number;
  datumnaechstepruefung: string;
  pmnummer: string;
  datumnaechstepruefung2: string;
  baujahr: string;
  baumusterpruefung: string;
}

export interface IMessmittelDatenResponse extends IApiSuccess, IMessmittelUO {}

export interface IFormularDatumSuchErgebnis {
  wert: string | null;
}

export interface IFormularDatumSucheResponse extends IApiSuccess, IFormularDatumSuchErgebnis {}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/models/ApiTypes.ts